/**
 * Valores default (locais) das feature flags.
 *
 * A fonte da verdade é a API (GET /feature-flags/{feature}); estes valores só são
 * usados enquanto a API responde, em erro de rede/servidor e quando a flag não
 * existe no backend (404).
 *
 * Nova feature: adicione a chave aqui com `false` e crie a flag no backend
 * (`enabled`) para liberar. Use `useFeatureFlag` ou `<FeatureFlag>` para consumir.
 */
export const featureFlags = {
    "budget": false,
    "budget.manager": false,

    // Módulo de Atendimentos (chamado TAS)
    "tas-occurrence.tas": false,
    "tas-occurrence.logs-tab": true,
    "tas-occurrence.vehicle-container": true,
    "tas-occurrence.vinculated-occurrence": true,
};

export type FeatureFlagName = keyof typeof featureFlags;
